import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ConditionalRendering } from '@components/common/conditional-rendering';
interface ISearchInputBoxProps {
    placeholderId: string;
    searchQuery: string;
    handleQueryChange: (query: string) => void;
    handleClear: () => void;
}

const SearchInputBox = (props: ISearchInputBoxProps) => {
    const { placeholderId, searchQuery, handleQueryChange, handleClear } = props;
    const intl = useIntl();
    const placeholderText = intl.formatMessage({ id: placeholderId });
    return (
        <div className="search-input-box-container" role="search" 
            aria-label="Search input box" data-testid="search-input-box-container"
        >
            <FontAwesomeIcon icon={faSearch} className="icon-magnifier" aria-hidden="true" data-testid="search-icon"/>
            <input
                type="text"
                placeholder={placeholderText}
                value={searchQuery}
                onChange={(e) => handleQueryChange(e.target.value)}
                aria-label="Search input"
                data-testid="search-input"
            />
            <ConditionalRendering isTrue={searchQuery}>
                <button className="clear-btn" onClick={handleClear} aria-label="Clear search input" data-testid="clear-button">
                    <FontAwesomeIcon icon={faTimes} aria-hidden="true" data-testid="clear-icon"/>
                </button>
            </ConditionalRendering>
        </div>
    );
};

export default SearchInputBox;